import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { RatePackageEventType } from './rate-package.event.type';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import { Router, ActivatedRoute } from '@angular/router';
import { PackageData } from './models/packageData'
import { TweenMax, Quint } from 'gsap';
import { ModalErrorEventType } from '../../shared/modal-error/modal-error.event.type';
import * as moment from 'moment';
import { FormGroup } from '@angular/forms';
import { Pacote } from './models/pacote.model';

@Component({
  selector: 'app-rate-package',
  templateUrl: './rate-package.component.html',
  styleUrls: ['./rate-package.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class RatePackageComponent implements OnInit {

	@Input() formInvalid = false;
	hirePackage: Pacote;
	subtitle: string;
	flowStep: string;
	hasSubmited = false;
	canSend = false;
	isModal = true;
	isTabHirePackage = false;
	form: FormGroup;
	monthsNames: Array<string>;
	monthText: string;
	flows: Object = {
		'my-package': RatePackageEventType.STEPS.MY_PACKAGE,
		'extract':  RatePackageEventType.STEPS.EXTRACT,
		'others': RatePackageEventType.STEPS.OTHERS,
		'confirm': RatePackageEventType.STEPS.CONFIRM,
		'result': RatePackageEventType.STEPS.RESULT
	};

	title: Object = {
		'my-package': 'Pacote de Serviços',
		'extract':  'Pacote de Serviços',
		'others': 'Outros pacote de serviços',
		'confirm': 'Confirmação de Contratação de Pacote de Serviços',
		'result': 'Resumo de Contratação de Pacote de Serviços'
	};


	constructor(private route: ActivatedRoute) {}

	ngOnInit() {
		this.show();
		// this.subtitle = 'Dados referetes ao pacote contratado na vigência de 01/10/2019 à 01/11/2019';

		AppEventDispatcher.listen(RatePackageEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
			TweenMax.delayedCall(.6, () => {
				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, { bottom: 0, ease: Quint.easeOut });
				});
			});
		});

		AppEventDispatcher.listen(RatePackageEventType.ERROR, (data): any => {
			this.hasSubmited = false;
			this.canSend = false;
		});

		AppEventDispatcher.listen(RatePackageEventType.HIRE_PACKAGE, (data: any) => {
			this.isTabHirePackage = true;
			this.hirePackage = data.pacote as Pacote;
		});

		AppEventDispatcher.listen(RatePackageEventType.STEPS.CONFIRM, data => {
			this.flowStep = 'confirm';
		});

		this.listenModal();
	}

	show() {
		this.route.params.subscribe(params => {
			TweenMax.delayedCall(.3, () => {
				this.setStep(!params.month ? 'my-package' : 'extract');
			});
		});
	}

	setStep(step) {
		this.flowStep = step;
		AppEventDispatcher.dispatch(RatePackageEventType.STEPS.MY_PACKAGE, { show: false });
		AppEventDispatcher.dispatch(RatePackageEventType.STEPS.EXTRACT, { show: false });
		AppEventDispatcher.dispatch(RatePackageEventType.STEPS.OTHERS, { show: false });
		AppEventDispatcher.dispatch(this.flows[step], { show: true });
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, () => {
			this.canSend = false;
		});

		AppEventDispatcher.listen(RatePackageEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		});
	}

	onSetTitleSubtitle(data) {
		this.flowStep = data.step;
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="rate-packege"] .content', show: active, delay: delay });
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/rate-package.component.ts